module.exports = __webpack_public_path__ + "static/media/perfil.1aced43f.svg";